import {Component, Input, OnInit} from '@angular/core';
import {EventItem} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {
  ActionService,
  AuthenticationService,
  LoaderService,
  PublicEventsService,
  TOAST_STATE,
  ToastService
} from "@services";
import {AbstractComponent} from "../abstract.component";
import {LOGIN_ROUTE, USER_PROFILE_VIEW_ROUTE} from "../../app-routing.module";
import {Router} from "@angular/router";

@Component({
  selector: 'app-favorite-event-indicator',
  templateUrl: './favorite-event-indicator.component.html',
  styleUrls: ['./favorite-event-indicator.component.scss']
})
export class FavoriteEventIndicatorComponent extends AbstractComponent implements OnInit {
  @Input() asButton: boolean = true;
  @Input() eventItem?: EventItem;
  @Input() isPreviewComponent?: boolean;
  @Input() isXsComponent?: boolean = false;
  favoriteItems?: EventItem[];

  constructor(
    public translocoService: TranslocoService,
    private publicEventsService: PublicEventsService,
    private loaderService: LoaderService,
    private toastService: ToastService,
    private authenticationService: AuthenticationService, private router: Router,
    private actionService: ActionService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.push(this.publicEventsService.favoriteEvents.subscribe(favoriteEvents => {
      this.favoriteItems = favoriteEvents?.result ?? [];
    }));
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated();
  }

  isFavorite(): boolean {
    return !!this.favoriteItems?.find(value => this.eventItem?.id === value.id);
  }

  addToFavoritesButtonClicked(event: MouseEvent): void {
    if (this.isPreviewComponent) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    if (this.authenticationService.isAuthenticated()) {
      this.addToFavoritesAction();
    } else {
      this.toastService.showToast(TOAST_STATE.warning, this.translocoService.translate("event.favorite.save.warning"));
      this.actionService.addAction(() => {
        this.addToFavoritesAction();
        this.router.navigate([USER_PROFILE_VIEW_ROUTE], {
          queryParams: {
            tab: "favorites"
          },
        });
      });
      this.router.navigate([LOGIN_ROUTE]);
    }
  }

  addToFavoritesAction(): void {
    if ((this.favoriteItems?.length ?? 0) > 0) {
      this.innerAddToFavoritesAction();
    } else {
      this.publicEventsService.fetchUserFavoritesEvent().subscribe(favoriteEvents => {
        this.favoriteItems = favoriteEvents ?? [];
        this.innerAddToFavoritesAction();
      });
    }
  }

  innerAddToFavoritesAction () {
    this.loaderService.startLoading();
    if (this.eventItem?.id) {
      const action = this.isFavorite()
        ? this.publicEventsService.removeEventFromFavorites(this.eventItem!.id!)
        : this.publicEventsService.addEventToFavorites(this.eventItem!.id!);

      action.subscribe(actionResult => {
        if (actionResult.result) {
          this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate(
            this.isFavorite() ? "event.favorite.delete.success" : "event.favorite.save.success"
          ));
          this.publicEventsService.fetchUserFavoritesEvent().subscribe(_ => {
            this.loaderService.dismissLoading();
          });
        } else {
          this.loaderService.dismissLoading();
        }
      });
    }
  }
}
